module.exports = __webpack_public_path__ + "img/chat.dad1b3bf.svg";